// @flow

import './index.scss';
import * as React from 'react';

type Props = {|
    value: string | number
|};

const Tag = ({ value }: Props): React.Node => (
    <span className="Tag">{value}</span>
);

export default (React.memo<Props>(Tag): React$AbstractComponent<Props, mixed>);
